var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 40,
    viewBox: "0 0 145 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5942 19.0058C53.6195 19.3891 54.3982 20.0547 54.9306 21.0027C55.4629 21.9307 55.729 23.0198 55.729 24.2705C55.729 26.227 55.0784 27.7499 53.7772 28.8392C52.4957 29.9283 50.7903 30.473 48.661 30.473H39.3159V9.29358H48.661C50.5538 9.29358 52.0816 9.76756 53.2448 10.7155C54.4278 11.6637 55.0194 13.0452 55.0194 14.8608C55.0194 16.7567 54.2111 18.1384 52.5942 19.0058ZM49.9326 15.7683C49.9326 15.1633 49.7749 14.7497 49.4595 14.5279C49.144 14.306 48.6511 14.1951 47.9808 14.1951H44.3433V17.372H48.1879C49.3511 17.372 49.9326 16.8375 49.9326 15.7683ZM48.5428 25.5714C49.3314 25.5714 49.8736 25.4303 50.1693 25.148C50.4847 24.8452 50.6424 24.4015 50.6424 23.8165C50.6424 23.1913 50.4946 22.7476 50.1989 22.4852C49.9032 22.2029 49.3511 22.0617 48.5428 22.0617H44.3433V25.5714H48.5428Z",
    fill: "#413A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.14 30.4734H94.1657L90.3803 23.8775L86.7132 30.4734H80.7395L87.3638 19.46L81.0648 9.29382H87.0385L90.5281 15.3754L94.0178 9.29382H99.9917L93.5743 19.8534L100.14 30.4734Z",
    fill: "#413A2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33 12.0775C103.42 9.95941 105.993 8.90057 109.049 8.90057C112.105 8.90057 114.668 9.95941 116.738 12.0775C118.828 14.1751 119.873 16.7773 119.873 19.8837C119.873 22.9899 118.828 25.6021 116.738 27.72C114.668 29.8179 112.105 30.8666 109.049 30.8666C105.993 30.8666 103.42 29.8179 101.33 27.72C99.2598 25.6021 98.2249 22.9899 98.2249 19.8837C98.2249 16.7773 99.2598 14.1751 101.33 12.0775ZM113.159 15.5266C112.075 14.3769 110.705 13.8021 109.049 13.8021C107.392 13.8021 106.022 14.3769 104.938 15.5266C103.854 16.6563 103.311 18.1085 103.311 19.8837C103.311 21.6586 103.854 23.121 104.938 24.2709C106.022 25.4004 107.392 25.9652 109.049 25.9652C110.705 25.9652 112.075 25.4004 113.159 24.2709C114.244 23.121 114.786 21.6586 114.786 19.8837C114.786 18.1085 114.244 16.6563 113.159 15.5266Z",
    fill: "#413A2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.503 25.5719H141.461V34.5581H136.433V30.4734H123.865V34.5581H118.837V25.5719H121.735C122.07 25.1886 122.327 24.4725 122.504 23.4237L124.693 9.29382H138.503V25.5719ZM127.443 23.9381C127.384 24.3818 127.275 24.9264 127.118 25.5719H133.476V14.1954H128.951L127.443 23.9381Z",
    fill: "#413A2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1136 17.0392C68.381 17.0392 70.1258 17.6039 71.3482 18.7336C72.5705 19.8631 73.1818 21.5272 73.1818 23.7258C73.1818 25.9245 72.5409 27.5986 71.2594 28.7483C69.9977 29.898 68.2527 30.473 66.025 30.473H57.0642V9.29358H62.0918V17.0392H66.1136ZM74.2993 9.29358H79.3268V30.473H74.2993V9.29358ZM65.8179 25.5714C67.3361 25.5714 68.095 24.9361 68.095 23.6652C68.095 22.9996 67.9176 22.5357 67.5629 22.2736C67.2079 21.9911 66.6558 21.8499 65.9067 21.8499H62.0918V25.5714H65.8179Z",
    fill: "#413A2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_1859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 29,
    height: 34
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3329 3.49512H3.41626V36.5048H31.3329V3.49512Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_1859)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0298 26.0211L15.3117 34.958C12.1178 37.2023 7.75023 36.3727 5.55653 33.105C3.36284 29.8372 4.17371 25.3688 7.36767 23.1244L20.0858 14.1875C23.2797 11.9432 27.6473 12.7728 29.841 16.0405C32.0346 19.3083 31.2238 23.7767 28.0298 26.0211Z",
    fill: "#413A2E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_76_1859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 28,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1191 14.2158L15.3129 5.21698C12.119 2.97261 7.75145 3.80222 5.55776 7.06995C3.36406 10.3377 4.17493 14.8061 7.36889 17.0505L20.1751 26.0493C23.369 28.2936 27.7366 27.464 29.9302 24.1963C32.1239 20.9286 31.3131 16.4601 28.1191 14.2158Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8319 22.9862C17.4497 24.348 18.5199 26.412 18.5199 28.7227C18.5199 31.1765 17.4447 33.4363 15.6975 34.6738L27.2558 26.5611C24.9709 27.5237 22.4087 27.5806 20.175 26.011L15.8319 22.9862Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55814 7.07023C7.75174 3.80247 12.1194 2.97295 15.3132 5.21722L28.1193 14.2161C31.3133 16.4603 32.1243 20.9289 29.9305 24.1964C27.7369 27.4642 23.3692 28.2939 20.1752 26.0495L7.36912 17.0508C4.17514 14.8064 3.36435 10.338 5.55814 7.07023Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8321 22.9862C17.4497 24.3481 18.5201 26.4122 18.5201 28.7227C18.5201 31.1765 17.4448 33.4363 15.6978 34.674L27.2558 26.5613C24.9711 27.5239 22.4089 27.5806 20.1753 26.011L15.8321 22.9862Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82629 10.4029C13.6119 16.6475 20.2067 8.26328 22.6562 3.29046C23.982 2.94561 26.6809 1.96657 26.8691 0.809096C27.1045 -0.637895 27.0614 -5.40916 25.2147 -11.3921C23.3679 -17.375 15.7537 -13.6062 3.2345 -9.03576C-9.28465 -4.46508 -1.65564 2.59706 6.82629 10.4029Z",
    fill: "#C03AEC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92945 27.5005C13.715 33.7452 20.3099 25.3609 22.7591 20.3881C24.085 20.0432 26.7838 19.064 26.9721 17.9065C27.2074 16.4597 27.1643 11.6883 25.3177 5.70558C23.471 -0.277336 15.8566 3.49121 3.33747 8.06189C-9.18169 12.6326 -1.55249 19.6947 6.92945 27.5005Z",
    fill: "#6369F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8452 17.3233C20.5795 21.6804 25.181 15.8305 26.8898 12.3609C27.8149 12.1202 29.698 11.4371 29.8293 10.6295C29.9935 9.61997 29.9633 6.29085 28.675 2.11667C27.3865 -2.0577 22.0737 0.571624 13.339 3.76075C4.60425 6.94968 9.92711 11.8771 15.8452 17.3233Z",
    fill: "#36CF5D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4261 21.3211C39.3946 13.6042 31.5547 12.8747 27.3886 13.4745C26.7171 12.7 25.1635 11.2528 24.3201 11.6621C23.2658 12.1736 20.0604 14.4392 16.6343 18.5458C13.2082 22.6526 18.2709 26.264 25.4977 32.9635C32.7244 39.6629 34.9654 30.9671 37.4261 21.3211Z",
    fill: "#FD2E1B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6236 27.7443C26.3916 21.5138 18.3591 26.7992 14.8719 30.2206C13.6204 30.2312 10.9983 30.4703 10.52 31.3415C9.92216 32.4307 8.66594 36.1829 8.65626 41.2392C8.64639 46.2957 16.3175 44.8318 28.4892 43.7006C40.661 42.5693 35.9138 35.532 30.6236 27.7443Z",
    fill: "#FF8D32"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_76_1859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7638 10.577C28.1462 8.1446 21.8968 11.1192 19.0993 12.9106C18.1866 13.0135 16.2577 13.3252 15.844 13.7491C15.3268 14.2792 14.1302 16.0425 13.7445 18.2867C13.3587 20.531 19.0586 19.2803 28.0133 17.8242C36.9682 16.3681 34.0358 13.6178 30.7638 10.577Z",
    fill: "#FFE712"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_76_1859",
    x: -23.3679,
    y: -34.4814,
    width: 70.3374,
    height: 67.1071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_76_1859",
    x: -23.2649,
    y: -17.3839,
    width: 70.3374,
    height: 67.1071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_76_1859",
    x: -11.2676,
    y: -20.0389,
    width: 61.167,
    height: 58.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_76_1859",
    x: -4.46167,
    y: -8.40942,
    width: 62.1992,
    height: 63.7371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_76_1859",
    x: -11.3438,
    y: 4.85669,
    width: 67.4841,
    height: 59.9492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_76_1859",
    x: -6.27393,
    y: -10.3405,
    width: 60.2478,
    height: 49.8535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRu);
export default __webpack_public_path__ + "static/media/logoRU.20ceefc72b3462ffe16aa0c46e3dfff2.svg";
export { ForwardRef as ReactComponent };